import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function getWallet(options) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = options;

    invariant(baseUrl, 'baseUrl is a required param of getWallet()');
    invariant(brandId, 'brandId is a required param of getWallet()');
    invariant(country, 'country is a required param of getWallet()');
    invariant(uberToken, 'uberToken is a required param of getWallet()');
    invariant(clientId, 'clientId is a required param of getWallet()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wallet/card/gps/@self`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getWallet');
}
